export const MIA_CHATBOT_URL = "https://www.medibuddy.in/user/mia-chatbot";

export const openChatbot = ({ isMiaEnabled, location, legacyWidget }) => {
  if (isMiaEnabled === true) {
    location.assign(MIA_CHATBOT_URL);
    return "mia";
  }

  if (legacyWidget && typeof legacyWidget.open === "function") {
    legacyWidget.open();
  }
  return "legacy";
};
